import { FC } from 'react';

import Flower from '@/assets/flower.svg?react';
import Tax from '@/assets/tax.svg?react';
import Clock from '@/assets/time.svg?react';

import { useLingui } from '@lingui/react';
import dayjs from 'dayjs';

interface Props {
  date: string;
  isAccepted: boolean;
  tax: number;
}

const OfferCards: FC<Props> = ({ date, isAccepted, tax }) => {
  const { i18n } = useLingui();

  return (
    <div className="text-dark-gray-500 lg:max-w-[440px]">
      <div className="mb-2.5 flex w-full flex-col gap-2.5 rounded-md bg-gray-200 px-3.5 py-4 lg:mb-5  lg:gap-4 lg:p-9">
        <h2 className="h3 flex items-center gap-2">
          <Flower className="size-5 text-green-500" />
          {isAccepted
            ? i18n.t('Dodatkowe środki czekają na Twój podpis')
            : i18n.t('Nie czekaj, zaakceptuj już dziś')}
        </h2>
        {isAccepted ? (
          <p className="body-small">
            {i18n.t(
              'Skontaktujemy się z Tobą w ciągu 24 godzin w celu potwierdzenia danych. Po ich weryfikacji wyślemy dokumenty do podpisu.'
            )}
          </p>
        ) : (
          <>
            <p className="body-small">
              {i18n.t(
                'Niniejsza propozycja nie stanowi oferty w rozumieniu art. 66 Kodeksu Cywilnego.'
              )}{' '}
            </p>
            <div className="body-small flex items-center gap-2">
              <Clock className="size-4 text-blue-600" />
              <p>
                {i18n.t('Propozycja ważna do')}{' '}
                <span className="font-semibold">
                  {dayjs(date).format('HH:mm, DD.MM.YYYY r.')}
                </span>
              </p>
            </div>
          </>
        )}
      </div>
      {tax > 0 && (
        <div className="flex w-full flex-col gap-2.5 rounded-md bg-gray-200 px-3.5 py-4 lg:gap-4 lg:p-9">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-2">
            <Tax className="min-h-5 min-w-[58px]" />
            <p className="body-small">
              {i18n.t(
                'Sprzedaż szkody opodatkowana jest podatkiem dochodowym według stawki'
              )}{' '}
              <span className="font-semibold">{i18n.t('12%')}</span>.{' '}
            </p>
          </div>
          <p
            className="body-small"
            dangerouslySetInnerHTML={{
              __html: i18n.t(
                'Helpfind dopełni za Ciebie wszystkie formalności łącznie z wysyłką deklaracji PIT-11 do właściwego dla Ciebie Urzędu Skarbowego.'
              ),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default OfferCards;
